<template>
    <v-app>
        <div class="table-responsive border rounded">
            <v-data-table class="elevation-0"
            :headers="headers"
            :items="data"
            hide-default-footer
            dense
            :items-per-page="-1">
                <template v-slot:[`item.FechaCaptura`]="{ item }">
                    {{ onFormat(item.FechaCaptura, country) }}
                </template>
            </v-data-table>
        </div>
    </v-app>
</template>
<script>
import moment from 'moment-timezone'
import timezones from '@/assets/json/timezones.json'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    country: {
      type: String,
      default: () => ''
    }
  },
  data: () => ({
    headers: [
      { text: 'Evento', value: 'Evento' },
      { text: 'Fecha Captura', value: 'FechaCaptura' },
      { text: 'Ubicacion', value: 'Ubicacion' },
      { text: 'Siguiente Ubicacion', value: 'SiguienteUbicacion' }
    ]
  }),
  methods: {
    onFormat: function (date, country) {
      let c = timezones.find((e) => e.name === country.replace(' (the)', ''))
      if (c.name === 'United States of America') {
        c.name = 'New York'
      }
      var gt = moment.tz(String(date), 'DD/MM/YYYY hh:mm:ss', c.region + '/' + c.name.replace(/\s/g, '_'))
      var guatemala = gt.clone().tz('America/Guatemala')
      return guatemala.format('YYYY/MM/DD hh:mm A')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/company/components/tables/Screen4.vue